import React, {useEffect, useState} from "react";
import {Modal} from "antd";
import {useTranslation} from "react-i18next";
import ConfirmIcon from "../assets/icons/confirm-icon.svg";
import ErrorIcon from "../assets/icons/error-icon.svg";
import {ApiClient} from "../utils/ApiClient";

function WinningsModal({winningModalOpen, setWinningModalOpen, walletAddress}: any) {

    const {t} = useTranslation();
    const [jackpotWinningTickets, setJackpotWinningTickets] = useState<any>([]);


    const apiClientJackpotNotificationsUpdate = new ApiClient("https://cryptolottery777.com/public/jackpot/notifications/update");

    const apiClientJackpotWinning = new ApiClient("https://cryptolottery777.com/public/winningtickets");

    useEffect(() => {
        if (walletAddress) {
            apiClientJackpotWinning.post({walletAddress: walletAddress}).then(winningsRes => {
                setJackpotWinningTickets(winningsRes);
            })
        }
    },[walletAddress])


    return (
        <Modal
            open={winningModalOpen}
            footer={null}
            closeIcon={false}
            className="info-modal"
            centered
        >
            <div className="info-modal-body">
                <img src={ConfirmIcon} alt="icon" width="59" height="59"/>
                <div className="success-header">{t('Поздравляем победителей!')}</div>
                <div className="success-text">
                    {t('Выигрышные билеты:')}!
                    <div className="winning-tickets-group">
                        {jackpotWinningTickets?.map((el: any) => {
                            return (
                                <span className="winning-tickets">N{el?.ticketNumber},</span>
                            )
                        })}
                    </div>

                </div>
                <div className="success-text">
                    {t('Спасибо всем за участие!  Следите за новыми розыгрышами – удача может улыбнуться именно вам!')}!
                </div>
                <button className="success-button" onClick={() => {
                    apiClientJackpotNotificationsUpdate.post({walletAddress: walletAddress}).then(res => {
                    });
                    setWinningModalOpen(false)
                }}>
                    {t('Готово!')}
                </button>
            </div>
        </Modal>
    )
}

export default WinningsModal
